module.exports = __webpack_public_path__ + "static/media/dubai-hotel.25fdedbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/dubai-hotel.svg
// module id = 144
// module chunks = 0